import * as React from "react";
import BaseProductListLayout from "./BaseProductListLayout";
import ProductCreatePopup from "../containers/products/ProductCreatePopup";

export default function () {
  return BaseProductListLayout(<ProductCreatePopup />);
}
